// Compare bar chart categories (horizontal stacked bars in team compare view)
export const compareBarCategories = [
  { id: 'pass', label: 'Pass', statKey: 'passesAttempted', color: '#ef4444' },
  { id: 'shot', label: 'Shot', statKey: 'shotsAttempted', color: '#22c55e' },
  { id: 'carry', label: 'Carry', statKey: 'carries', color: '#3b82f6' }
] as const
